import { useTranslation } from 'react-i18next';
import './CommonRadioButton.scss';
import radioChecked from '../assets/images/radioCheckedIcon.svg';
import radioUnchecked from '../assets/images/radioUnCheckIcon.svg';

const CommonRadioWithLabel = ({ className = "", value, onChange, checked, label, name, id, ...props }) => {
    const { t } = useTranslation();
    const inputId = id || `common-radio-btn-id-${value}`;
    return (
        <div className={`common-radio-with-label ${className}`}>
            <input
                type="radio"
                id={inputId}
                className="common-radio-button"
                name={name}
                value={value}
                onChange={onChange}
                checked={checked}
                {...props}
            />
            <label className="common-radio-label" htmlFor={inputId}>
                <img
                    src={checked ? radioChecked : radioUnchecked}
                    alt="radio button"
                    className="common-radio-icon"
                />
                {t(label)}
            </label>
        </div>
    );
};

export default CommonRadioWithLabel;
